import { render } from "./TaskCreated.vue?vue&type=template&id=63d1244a"
import script from "./TaskCreated.vue?vue&type=script&lang=js"
export * from "./TaskCreated.vue?vue&type=script&lang=js"
script.render = render

export default script